import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import RevertBackModal from "./revertBackSupplier";
import GraphicDesingerMokup from "../Buyer/GraphicDesignerMokup";
import Modal, { KeyValue } from "../../../Components/Modal";
import OrderSpecsModal, {
  ProductImageStack,
  ProductImagesModal,
  displayValue,
} from "../../../Components/OrderSpecsModal";
import { formatMoney } from "../../../utils/money";
import { openAdminChat } from "../../../utils/openAdminChat";

const request = localStorage.getItem("request");

const Inbound = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;
  const [finalPrice, setFinalPrice] = useState("");
  const [finalDescription, setFinalDescription] = useState("");
  const [approvalDesc, setApprovalDesc] = useState("");
  const [activePreviewIndex, setActivePreviewIndex] = useState(0);
  const [orderIds, setOrderAssignedIds] = useState(() => {
    return localStorage.getItem("order_id");
  });

  const handleRowClick = (id) => {
    const newId = orderIds === id ? null : id;
    setOrderAssignedIds(newId);

    if (newId) {
      localStorage.removeItem("order_id");
    } else {
      localStorage.removeItem("order_id");
    }
  };

  const profileString = localStorage.getItem("user");
  const user = JSON.parse(localStorage.getItem("user"));
  let admin_id = null;
  let token = null;

  if (profileString) {
    try {
      if (profileString != "undefined" || profileString === null) {
        const profile = JSON.parse(profileString);
        admin_id = profile.id || profile.admin_id;
        token = profile.token || profile.access_token;
      }
    } catch (err) {
      console.error("Failed to parse profile:", err);
    }
  }

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showDesignModal, setShowDesignModal] = useState(false);
  const [userId, setUserId] = useState(0);
  const [order_assigned_id, setOrderAssignedId] = useState(0);
  const [orderid, setOrderId] = useState(0);
  const [monthFilter, setMonthFilter] = useState("");
  const [QuotationlModal, setQuotationlModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedDesignIndexes, setSelectedDesignIndexes] = useState({});
  const [isMobileView, setIsMobileView] = useState(false);
  const [openDesc, setOpenDesc] = useState(false);
  const [descContent, setDescContent] = useState("");
  // Assignment row whose full spec sheet is open (null = closed).
  const [specsItem, setSpecsItem] = useState(null);
  // Assignment row whose product-image gallery is open (null = closed).
  const [galleryItem, setGalleryItem] = useState(null);
  // Admin price the supplier is responding to: { id, price } (null = closed).
  const [respondTo, setRespondTo] = useState(null);
  const [counterMode, setCounterMode] = useState(false);
  const [counterPrice, setCounterPrice] = useState("");
  const [counterReason, setCounterReason] = useState("");
  const [counterErrors, setCounterErrors] = useState({});
  const [isResponding, setIsResponding] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleThumbnailClick = (rowIndex, designIndex) => {
    setSelectedDesignIndexes((prev) => ({
      ...prev,
      [rowIndex]: designIndex,
    }));
  };

  const handleOpenQuotation = (
    order_assigned_id,
    quotation_price,
    remark,
    approved
  ) => {
    setSelectedOrderId(order_assigned_id);
    setFinalDescription(remark);
    setApprovalDesc(approved);
    setFinalPrice(quotation_price);
    setQuotationlModal(true);
  };

  const handleOpenModal = (userId, order_assigned_id) => {
    setUserId(userId);
    setOrderAssignedId(order_assigned_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDesignOpenModal = (userId, order_id) => {
    setUserId(userId);
    setOrderId(order_id);
    setShowDesignModal(true);
  };

  const handleDesignCloseModal = () => {
    setShowDesignModal(false);
  };

  // Responding to the admin price was two stacked SweetAlerts: a question box,
  // then a second one with two bare unlabelled inputs injected as raw HTML and
  // validation shown as a red banner. Both steps now use the shared modal, so
  // the fields get labels, real widths and inline errors like every other form.
  const HandleActiveDeactive = (id, price) => {
    setRespondTo({ id, price });
    setCounterMode(false);
    setCounterPrice("");
    setCounterReason("");
    setCounterErrors({});
  };

  const closeRespond = () => {
    if (isResponding) return;
    setRespondTo(null);
    setCounterMode(false);
  };

  const acceptOffer = async () => {
    if (respondTo?.price == null) {
      toast.error("Quotation already sent");
      return;
    }
    setIsResponding(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/admin/quotation/send/supplier/finalPrice/${respondTo.id}`,
        { status: "accept", price: respondTo.price },
        { headers: { Authorization: `Bearer ${localStorage.getItem("Token")}` } }
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setRespondTo(null);
        SupplierLeadData();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setIsResponding(false);
    }
  };

  const submitCounter = async () => {
    const errors = {};
    if (!String(counterPrice).trim()) {
      errors.price = "Enter the price you want.";
    } else if (Number.isNaN(Number(counterPrice)) || Number(counterPrice) <= 0) {
      errors.price = "Enter a valid amount.";
    }
    if (!counterReason.trim()) errors.reason = "Tell the admin why.";

    setCounterErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setIsResponding(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/admin/quotation/send/supplier/finalPrice/${respondTo.id}`,
        {
          status: "reject",
          price: counterPrice,
          description: counterReason,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("Token")}` } }
      );
      if (res.status === 200 && res.data.success) {
        toast.success(res.data.message);
        setRespondTo(null);
        setCounterMode(false);
        SupplierLeadData();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setIsResponding(false);
    }
  };

  // // Extracted error handling for reuse
  // const handleAxiosError = (err) => {
  //   const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
  //   const STATUS = [401, 403];
  //   if (
  //     STATUS.includes(err?.response?.status) ||
  //     MSG.includes(err?.response?.data?.msg)
  //   ) {
  //     localStorage.clear();
  //     Navigate("/admin/login");
  //   } else {
  //     toast.error(err?.response?.data?.msg);
  //   }
  // };

  useEffect(() => {
    return () => {
      if (location.state !== null) {
        if (is_alert === false) {
          toast.success(location.state);
        }
        is_alert = true;
      }
      window.history.replaceState({}, location.state);
    };
  }, []);

  // This page is the supplier's own "Inbound" quotation list, so the chat
  // icon here contacts Admin Support — the same default contact chatModal.jsx
  // falls back to for any non-admin user — via the real Live Chat widget
  // (Layout/chatModal.jsx, mounted globally in header.jsx) instead of the
  // removed local stub, which used a WebSocket action ("supplier_send_message")
  // the backend never implemented.
  const handleOpenChat = () => {
    openAdminChat({
      user_id: 1,
      name: "Admin Support",
      email: "admin@packgenie.com",
      user_type: "admin",
    });
  };

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const SupplierLeadData = () => {
    const monthQuery = monthFilter ? `&month=${monthFilter}` : "";
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/quotation/receive/supplier/${user.user_id}${monthQuery}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        const responseData = res?.data?.data;

        // Latest inbound first. Sort explicitly by created_at so ordering does
        // not depend on the order rows happen to come back in.
        const sortedData = Array.isArray(responseData)
          ? [...responseData].sort(
              (a, b) =>
                new Date(b?.created_at).getTime() -
                new Date(a?.created_at).getTime()
            )
          : responseData;

        setTotalPage(res?.data?.data?.pages);
        setData(sortedData);
      })
      .catch((err) => {
        setActivePreviewIndex(0);
        if (err?.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  useEffect(() => {
    SupplierLeadData();
  }, [page, search, monthFilter]);

  const styles = {
    chatIcon: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      cursor: "pointer",
      backgroundColor: "#25D366",
      padding: "12px",
      borderRadius: "50%",
    },
    chatModal: {
      position: "fixed",
      bottom: "80px",
      right: "20px",
      width: "300px",
      height: "400px",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      zIndex: 999,
    },
    chatHeader: {
      backgroundColor: "#1b55e2 ",
      color: "white",
      padding: "10px",
      fontWeight: "bold",
      display: "flex",
      justifyContent: "space-between",
    },
    closeButton: {
      cursor: "pointer",
      fontSize: "18px",
    },
    chatBody: {
      flex: 1,
      padding: "10px",
      overflowY: "auto",
      background: "#f0f0f0",
    },
    sentMessage: {
      margin: "5px 0",
      padding: "8px 12px",
      borderRadius: "18px",
      maxWidth: "70%",
      backgroundColor: "#dcf8c6",
      alignSelf: "flex-end",
      marginLeft: "auto",
    },
    receivedMessage: {
      margin: "5px 0",
      padding: "8px 12px",
      borderRadius: "18px",
      maxWidth: "70%",
      backgroundColor: "#fff",
      alignSelf: "flex-start",
      marginRight: "auto",
    },
    chatFooter: {
      padding: "10px",
      display: "flex",
      gap: "5px",
      borderTop: "1px solid #ccc",
    },
    chatInput: {
      flex: 1,
      padding: "8px",
      borderRadius: "20px",
      border: "1px solid #ccc",
    },
    sendButton: {
      backgroundColor: "#1b55e2",
      border: "none",
      color: "white",
      padding: "8px 12px",
      borderRadius: "20px",
      cursor: "pointer",
    },
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case "Pending":
        return <span className="badge badge-warning">{status}</span>;
      case "Approved":
        return <span className="badge badge-success">{status}</span>;
      case "Rejected":
        return <span className="badge badge-danger">{status}</span>;
      case "In Progress":
        return <span className="badge badge-info">{status}</span>;
      case "Completed":
        return <span className="badge badge-primary">{status}</span>;
      default:
        return <span className="badge badge-secondary">{status}</span>;
    }
  };

  const renderDesktopView = () => (
    <table
      id="default-ordering"
      className="bpl-table bpl-table--wf"
      style={{ width: "100%" }}
      role="grid"
      aria-describedby="default-ordering_info"
    >
      <thead>
        <tr role="row">
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Product Name
          </th>
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Product Description
          </th>

          <th
            className="sorting col-1"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Specs
          </th>

          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            SIZE
          </th>
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Quantity
          </th>
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Material Color
          </th>
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Date&Time
          </th>

          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Send Quotation
          </th>
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Admin Quotation
          </th>

          {/* <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Your Final Quote
          </th> */}
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Status
          </th>
          <th
            className="sorting col-2"
            tabIndex={0}
            rowSpan={1}
            colSpan={1}
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "center",
            }}
          >
            Design Studio
          </th>
          {/* <th>Action</th> */}
        </tr>
      </thead>
      <tbody>
        {data?.length !== 0 ? (
          <>
            {data?.map((item, index) => (
              <tr
                role="row"
                key={index}
                onClick={() => handleRowClick(item?.order_id)}
                style={{
                  backgroundColor:
                    orderIds === String(item?.order_id)
                      ? "#e3f2fd"
                      : "transparent",
                }}
              >
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    {/* Thumbnails of what the supplier is quoting on. */}
                    {/* <ProductImageStack
                      images={item?.product?.product_image}
                      emptyLabel=""
                      onOpen={() => setGalleryItem(item)}
                    /> */}
                    <span>{item?.order?.title}</span>
                  </div>
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                    maxWidth: "220px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      maxWidth: "220px",
                    }}
                  >
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "180px", // ensures space for the icon
                      }}
                      title={
                        item?.order?.product_description || "No Description"
                      }
                    >
                      {item?.order?.product_description || "—"}
                    </div>

                    {/* A solid blue disc pulled the eye away from the text it
                        belongs to. Use the same quiet outlined icon-button as
                        every other row action. */}
                    {item?.order?.product_description && (
                      <button
                        type="button"
                        className="al-act"
                        style={{ width: 24, height: 24, flexShrink: 0 }}
                        title="Read the full description"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDescContent(item?.order?.product_description);
                          setOpenDesc(true);
                        }}
                      >
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>
                      </button>
                    )}
                  </div>
                </td>

                {/* Specs — full sheet (all specs + product images) in a modal */}
                <td style={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                  <button
                    type="button"
                    className="al-act al-act--primary"
                    title="View full product specs & images"
                    style={{ margin: "0 auto" }}
                    onClick={() => setSpecsItem(item)}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                  </button>
                </td>

                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {displayValue(item?.order?.size)}
                </td>

                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {displayValue(item?.order?.quantity)}
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {displayValue(item?.order?.material_color)}
                </td>

                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {new Date(item.created_at).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                  })}
                </td>

                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  <div className="wf-cell">
                    {(() => {
                      const isDisabled =
                        item?.quotation_price !== null ||
                        item?.status === "waiting_for_final_approval" ||
                        item?.status === "rejected";

                      return (
                        <button
                          type="button"
                          title="Send quotation"
                          className={`wf-iconbtn wf-iconbtn--primary ${
                            isDisabled ? "is-disabled" : ""
                          }`}
                          onClick={() => {
                            if (!isDisabled) {
                              handleOpenModal(admin_id, item.order_assigned_id);
                            }
                          }}
                        >
                          <svg
                            fill="currentColor"
                            viewBox="0 0 576 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"></path>
                          </svg>
                        </button>
                      );
                    })()}

                    {/* The amount sat in a bordered pill with a separate
                        outlined "i" circle beside it — two shapes for one
                        action. One button, one border. */}
                    {item?.quotation_price !== null &&
                    item?.quotation_price !== undefined &&
                    item?.quotation_price !== "" ? (
                      <button
                        type="button"
                        className="wf-price wf-price--btn"
                        title="View your quotation"
                        onClick={() =>
                          handleOpenQuotation(
                            item.order_assigned_id,
                            item?.quotation_price,
                            item?.remark,
                            item?.quotationApproved
                          )
                        }
                      >
                        {formatMoney(item?.quotation_price)}
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
                      </button>
                    ) : (
                      <span className="wf-dash">—</span>
                    )}
                  </div>
                </td>

                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {item?.admin_quotation_price ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 9,
                        flexWrap: "wrap",
                      }}
                    >
                      <span
                        style={{
                          background: "var(--color-primary-weak)",
                          color: "var(--color-primary)",
                          fontFamily: "var(--font-mono)",
                          fontWeight: 700,
                          padding: "2px 9px",
                          borderRadius: 6,
                        }}
                      >
                        {formatMoney(item.admin_quotation_price)}
                      </span>

                      {/*
                        This was an unlabelled pill-with-a-dot SVG that looked
                        like a disabled toggle — nothing said it was the accept /
                        decline control for the admin counter-offer, and the
                        "pending" variant rendered with empty <text>. Say what it
                        is, and what you already answered.
                      */}
                      {(() => {
                        // Accepting sets status to waiting_for_final_approval
                        // (see sendAdminPrice) — NOT "approved", which only
                        // happens later. Missing that state left "Respond"
                        // showing after the supplier had already accepted.
                        // Countering instead writes
                        // supplier_to_admin_quotation_price and bumps
                        // send_count, leaving status untouched.
                        const answered = {
                          waiting_for_final_approval: {
                            label: "You accepted",
                            bg: "var(--color-success-bg)",
                            fg: "var(--color-success-text)",
                          },
                          approved_by_sub_admin: {
                            label: "You accepted",
                            bg: "var(--color-success-bg)",
                            fg: "var(--color-success-text)",
                          },
                          approved: {
                            label: "Accepted",
                            bg: "var(--color-success-bg)",
                            fg: "var(--color-success-text)",
                          },
                          // Suppliers never set "rejected" on themselves; the
                          // admin does, when another supplier wins.
                          rejected: {
                            label: "Not selected",
                            bg: "var(--color-danger-bg)",
                            fg: "var(--color-danger-text)",
                          },
                        }[item?.status];

                        if (answered) {
                          return (
                            <span
                              className="al-pill"
                              style={{
                                background: answered.bg,
                                color: answered.fg,
                              }}
                            >
                              {answered.label}
                            </span>
                          );
                        }

                        // Sourcing closes when the buyer quotation goes out. The
                        // API sends this as a flag rather than the buyer price,
                        // which a supplier must not see.
                        if (item?.sourcing_closed) {
                          return (
                            <span
                              className="al-pill"
                              style={{
                                background: "var(--color-surface-2)",
                                color: "var(--color-text-tertiary)",
                              }}
                              title="The admin has sent the final quotation to the buyer."
                            >
                              Closed
                            </span>
                          );
                        }

                        // Countered back, or out of replies (the server refuses
                        // once send_count hits 2) — nothing left to do here.
                        if (
                          item?.supplier_to_admin_quotation_price != null ||
                          (item?.send_count ?? 0) >= 2
                        ) {
                          return (
                            <span
                              className="al-pill"
                              style={{
                                background: "var(--color-warning-bg)",
                                color: "var(--color-warning-text)",
                              }}
                            >
                              Awaiting admin
                            </span>
                          );
                        }

                        return (
                          <button
                            type="button"
                            className="al-btn al-btn--primary"
                            style={{ height: 28, padding: "0 11px", fontSize: 11.5 }}
                            title="Accept or counter this price"
                            onClick={() =>
                              HandleActiveDeactive(
                                item?.order_assigned_id,
                                item.admin_quotation_price
                              )
                            }
                          >
                            Respond
                          </button>
                        );
                      })()}
                    </div>
                  ) : (
                    <span className="wf-dash">No quotation</span>
                  )}
                </td>
                {/* <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {item?.final_price}
                </td> */}
                <td style={{ textAlign: "center" }}>
                  {(() => {
                    const st = item?.status;
                    const meta =
                      st === "pending"
                        ? { cls: "wf-status--pending", label: "Pending" }
                        : st === "waiting_for_final_approval"
                        ? { cls: "wf-status--wait", label: "Waiting for approval" }
                        : st === "approved"
                        ? { cls: "wf-status--approved", label: "Approved" }
                        : { cls: "wf-status--rejected", label: "Rejected" };
                    return (
                      <span className={`wf-status ${meta.cls}`}>
                        {meta.label}
                      </span>
                    );
                  })()}
                </td>

                <td
                  style={{
                    fontSize: "14px",
                    color: "black",

                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    {/* Circular 40px avatars with a hardcoded white border and
                        a -24px overlap crowded the edit icon and cropped the
                        artwork. Use the same stack every other table uses. */}
                    <ProductImageStack
                      images={(item?.designs || [])
                        .map((d) => d?.design_url)
                        .filter(Boolean)}
                      emptyLabel=""
                      title={
                        item?.status === "Rejected"
                          ? "Quotation rejected"
                          : "Preview designs"
                      }
                      onOpen={() => {
                        if (item?.status !== "Rejected") {
                          handleThumbnailClick(index);
                          handleDesignOpenModal(
                            item?.order?.user_id,
                            item.order_id
                          );
                        }
                      }}
                    />

                    {request === "Create Mokeup" &&
                      orderIds === String(item?.id) && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            width: "14px",
                            height: "14px",
                            borderRadius: "50%",
                            backgroundColor: "red",
                            boxShadow: "0 0 0 2px white",
                            transition: "all 0.3s ease-in-out",
                          }}
                        ></span>
                      )}

                    {/* A bare <svg onClick> gives no hit area, no hover and no
                        tooltip. Use the shared icon-button so it matches every
                        other row action. */}
                    <button
                      type="button"
                      className="al-act al-act--primary"
                      title={
                        item?.status === "Rejected"
                          ? "Quotation rejected"
                          : "Open design studio"
                      }
                      disabled={item?.status === "Rejected"}
                      style={{
                        opacity: item?.status === "Rejected" ? 0.5 : 1,
                        cursor:
                          item?.status === "Rejected"
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onClick={() => {
                        if (item?.status !== "Rejected") {
                          handleDesignOpenModal(
                            item?.order?.user_id,
                            item.order_id
                          );
                        }
                      }}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z" /></svg>
                    </button>
                  </div>
                </td>

                {/* <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    onClick={() => {
                      handleOpenChat(item?.userData?.id);
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#25D366"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 014 11.5a8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                  </svg>
                </td> */}
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={12} style={{ padding: 0 }}>
              <div className="al-empty">
                <div className="al-empty__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                  </svg>
                </div>
                <p className="al-empty__title">No Inbound Orders Found</p>
                <p className="al-empty__text">
                  Supplier quotation requests will appear here.
                </p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );

  const renderMobileView = () => (
    <div className="row">
      {data?.length !== 0 ? (
        data.map((item, index) => (
          <div key={index} className="col-12 mb-3">
            <div
              className="card"
              style={{
                backgroundColor:
                  orderIds === String(item?.order_id) ? "#e9f4ff" : "#ffffff",
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                transition: "all 0.3s ease-in-out",
              }}
              onClick={() => handleRowClick(item?.order_id)}
            >
              {/* Order Info Section */}
              <div className="row mb-3">
                <div className="col-12">
                  {[
                    {
                      label: "Product",
                      value: item?.product?.title,
                      icon: "📦",
                    },
                    {
                      label: "Size",
                      value: displayValue(
                        item?.order?.size || item?.product?.size
                      ),
                      icon: "📐",
                    },
                    {
                      label: "Qty",
                      value: displayValue(
                        item?.order?.quantity || item?.product?.quantity
                      ),
                      icon: "🔢",
                    },
                    {
                      label: "Color",
                      value: displayValue(
                        item?.order?.material_color ||
                          item?.product?.material_color
                      ),
                      icon: "🎨",
                    },
                    {
                      label: "Date",
                      value: new Date(item.created_at).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                      }),
                      icon: "📅",
                    },
                    {
                      label: "Status",
                      value: item?.status,
                      icon: "📌",
                      isBadge: true,
                    },
                  ].map((info, idx) => (
                    <div
                      key={idx}
                      className="d-flex justify-content-between border-bottom py-1"
                    >
                      <div>
                        <strong>{info.label}:</strong>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {info.isBadge ? (
                          <span
                            style={{
                              backgroundColor: "#6f42c1",
                              color: "#fff",
                              padding: "2px 8px",
                              fontSize: "12px",
                              borderRadius: "12px",
                            }}
                          >
                            {info.value}
                          </span>
                        ) : (
                          <>
                            <span>{info.value}</span>
                          </>
                        )}
                        <span>{info.icon}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Full specs + product images */}
              <button
                type="button"
                className="al-btn"
                style={{ width: "100%", justifyContent: "center", marginBottom: 12 }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSpecsItem(item);
                }}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                View specs & images
              </button>

              {/* Quotation Info */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <strong>Send Quotation:</strong>
                <div className="d-flex align-items-center gap-2">
                  <button
                    onClick={() =>
                      handleOpenModal(admin_id, item.order_assigned_id)
                    }
                    disabled={item?.quotation_price != null}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor:
                        item?.quotation_price != null
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    <svg
                      width="22"
                      height="22"
                      fill="#444"
                      style={{
                        opacity: item?.quotation_price != null ? 0.4 : 1,
                      }}
                    >
                      <use href="#send-icon" />
                    </svg>
                  </button>

                  <div
                    onClick={() =>
                      handleOpenQuotation(
                        item.order_assigned_id,
                        item?.quotation_price,
                        item?.remark,
                        item?.quotationApproved
                      )
                    }
                    title="Quotation"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        border: "1px solid #0d6efd",
                        color: "#0d6efd",
                        fontSize: "12px",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontWeight: 500,
                      }}
                    >
                      ₹{item?.quotation_price}
                    </span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#17a2b8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="8" />
                      <line x1="12" y1="12" x2="12" y2="16" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Admin Quotation */}
              {item?.admin_quotation_price && (
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <strong>Admin Quotation:</strong>
                  <div className="d-flex align-items-center gap-2">
                    <span
                      style={{
                        background: "var(--color-primary-weak)",
                        color: "var(--color-primary)",
                        fontFamily: "var(--font-mono)",
                        fontWeight: 700,
                        fontSize: 12,
                        padding: "3px 10px",
                        borderRadius: 6,
                      }}
                    >
                      {formatMoney(item.admin_quotation_price)}
                    </span>

                    {/* Same accept/decline control as the table view — the bare
                        red/green "Yes"/"No" chip did not say what it answered. */}
                    {(() => {
                      // Accepting sets status to waiting_for_final_approval
                      // (see sendAdminPrice) — NOT "approved", which only
                      // happens later. Missing that state left "Respond"
                      // showing after the supplier had already accepted.
                      // Countering instead writes
                      // supplier_to_admin_quotation_price and bumps
                      // send_count, leaving status untouched.
                      const answered = {
                        waiting_for_final_approval: {
                          label: "You accepted",
                          bg: "var(--color-success-bg)",
                          fg: "var(--color-success-text)",
                        },
                        approved_by_sub_admin: {
                          label: "You accepted",
                          bg: "var(--color-success-bg)",
                          fg: "var(--color-success-text)",
                        },
                        approved: {
                          label: "Accepted",
                          bg: "var(--color-success-bg)",
                          fg: "var(--color-success-text)",
                        },
                        // Suppliers never set "rejected" on themselves; the
                        // admin does, when another supplier wins.
                        rejected: {
                          label: "Not selected",
                          bg: "var(--color-danger-bg)",
                          fg: "var(--color-danger-text)",
                        },
                      }[item?.status];

                      if (answered) {
                        return (
                          <span
                            className="al-pill"
                            style={{
                              background: answered.bg,
                              color: answered.fg,
                            }}
                          >
                            {answered.label}
                          </span>
                        );
                      }

                      // Sourcing closes when the buyer quotation goes out. The
                      // API sends this as a flag rather than the buyer price,
                      // which a supplier must not see.
                      if (item?.sourcing_closed) {
                        return (
                          <span
                            className="al-pill"
                            style={{
                              background: "var(--color-surface-2)",
                              color: "var(--color-text-tertiary)",
                            }}
                            title="The admin has sent the final quotation to the buyer."
                          >
                            Closed
                          </span>
                        );
                      }

                      // Countered back, or out of replies (the server refuses
                      // once send_count hits 2) — nothing left to do here.
                      if (
                        item?.supplier_to_admin_quotation_price != null ||
                        (item?.send_count ?? 0) >= 2
                      ) {
                        return (
                          <span
                            className="al-pill"
                            style={{
                              background: "var(--color-warning-bg)",
                              color: "var(--color-warning-text)",
                            }}
                          >
                            Awaiting admin
                          </span>
                        );
                      }

                      return (
                        <button
                          type="button"
                          className="al-btn al-btn--primary"
                          style={{ height: 28, padding: "0 11px", fontSize: 11.5 }}
                          title="Accept or counter this price"
                          onClick={() =>
                            HandleActiveDeactive(
                              item?.order_assigned_id,
                              item.admin_quotation_price
                            )
                          }
                        >
                          Respond
                        </button>
                      );
                    })()}
                  </div>
                </div>
              )}

              {/* Design Studio */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <strong>Design Studio:</strong>
                <div className="d-flex align-items-center gap-2">
                  <ProductImageStack
                    images={(item?.designs || [])
                      .map((d) => d?.design_url)
                      .filter(Boolean)}
                    emptyLabel=""
                    title="Preview designs"
                    onOpen={() => {
                      handleThumbnailClick(index);
                      handleDesignOpenModal(item?.order?.user_id, item.order_id);
                    }}
                  />

                  <svg
                    onClick={() =>
                      handleDesignOpenModal(item?.userData?.id, item.order_id)
                    }
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="#515365"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ cursor: "pointer" }}
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </div>
              </div>

              {/* Chat Icon */}
              <div className="text-end">
                <svg
                  onClick={() => handleOpenChat()}
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  fill="none"
                  stroke="#25D366"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ cursor: "pointer" }}
                >
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 014 11.5a8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                </svg>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="al-empty">
          <div className="al-empty__icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
          </div>
          <p className="al-empty__title">No Inbound Orders Found</p>
          <p className="al-empty__text">
            Supplier quotation requests will appear here.
          </p>
        </div>
      )}
    </div>
  );

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="al-head">
        <div>
          <h1 className="al-title">Inbound</h1>
          <p className="al-sub">Inbound supplier orders.</p>
        </div>
      </div>

        <div className="al-card bpl-card">
          <div className="widget-content widget-content-area p-0 box-shadow-none">
            <div className="table-responsive">
              <div
                id="default-ordering_wrapper"
                className="dataTables_wrapper container-fluid dt-bootstrap4"
              >
                <div className="al-toolbar">
                  <div className="al-search">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="var(--color-text-tertiary)"
                      strokeWidth="2"
                      strokeLinecap="round"
                    >
                      <circle cx="11" cy="11" r="7" />
                      <path d="m21 21-4.3-4.3" />
                    </svg>
                    <input
                      type="search"
                      placeholder="Search inbound orders…"
                      aria-controls="default-ordering"
                      onKeyDown={(e) => {
                        e.key === "Enter" && search !== "" && SupplierLeadData();
                      }}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="al-select">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <select
                      value={monthFilter}
                      onChange={(e) => {
                        setMonthFilter(e.target.value);
                        SupplierLeadData();
                      }}
                    >
                      <option value="">Select Month</option>
                      <option value="All">All</option>
                      <option value="1">Last 1 Month</option>
                      <option value="3">Last 3 Months</option>
                      <option value="6">Last 6 Months</option>
                    </select>
                  </div>
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: "11.5px",
                      color: "var(--color-text-tertiary)",
                      fontWeight: 600,
                    }}
                  >
                    Tap a row to select its order
                  </span>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    {isMobileView ? (
                      renderMobileView()
                    ) : (
                      // The table (bpl-table--wf, many columns) had no
                      // horizontal-scroll container at all, so on
                      // narrower/laptop widths it overflowed straight
                      // into the page — the whole body scrolled
                      // sideways instead of just this table.
                      <div style={{ width: "100%", overflowX: "auto" }}>
                        {renderDesktopView()}
                      </div>
                    )}

                    {/* The chat icon (below, in renderDesktopView/renderMobileView)
                        now opens the real Live Chat widget from
                        Layout/chatModal.jsx via openAdminChat() — this stub
                        panel never had a working send (its messages were
                        hardcoded to "Hello how can help you" and its
                        WebSocket protocol didn't match the backend). */}

                    <Modal
                      open={QuotationlModal}
                      onClose={() => setQuotationlModal(false)}
                      title="Send Quotation"
                      subtitle="Quotation you sent for this order"
                      size="sm"
                      footer={
                        <button
                          type="button"
                          className="al-btn"
                          onClick={() => setQuotationlModal(false)}
                        >
                          Close
                        </button>
                      }
                    >
                      <div className="al-kv">
                        <KeyValue label="Quotation Price">
                          {formatMoney(finalPrice)}
                        </KeyValue>
                        <KeyValue label="Status">
                          {(() => {
                            const meta =
                              approvalDesc === 1
                                ? {
                                    label: "Approved",
                                    bg: "var(--color-success-bg)",
                                    fg: "var(--color-success-text)",
                                  }
                                : approvalDesc === 2
                                ? {
                                    label: "Rejected",
                                    bg: "var(--color-danger-bg)",
                                    fg: "var(--color-danger-text)",
                                  }
                                : {
                                    label: "Pending",
                                    bg: "var(--color-warning-bg)",
                                    fg: "var(--color-warning-text)",
                                  };
                            return (
                              <span
                                className="al-pill"
                                style={{ background: meta.bg, color: meta.fg }}
                              >
                                {meta.label}
                              </span>
                            );
                          })()}
                        </KeyValue>
                      </div>
                      <div style={{ marginTop: 16 }}>
                        <KeyValue label="Remark">
                          {finalDescription || "—"}
                        </KeyValue>
                      </div>
                    </Modal>

                    {/* Respond to the admin price */}
                    <Modal
                      open={!!respondTo}
                      onClose={closeRespond}
                      title={
                        counterMode
                          ? "Send a counter offer"
                          : "Respond to this price"
                      }
                      subtitle={
                        counterMode
                          ? "The admin will review your price before the order moves on."
                          : "Accept the admin price, or propose your own."
                      }
                      size="sm"
                      footer={
                        counterMode ? (
                          <>
                            <button
                              type="button"
                              className="al-btn"
                              onClick={() => setCounterMode(false)}
                              disabled={isResponding}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="al-btn al-btn--primary"
                              onClick={submitCounter}
                              disabled={isResponding}
                            >
                              {isResponding ? "Sending…" : "Send to admin"}
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="al-btn"
                              onClick={closeRespond}
                              disabled={isResponding}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="al-btn"
                              onClick={() => setCounterMode(true)}
                              disabled={isResponding}
                            >
                              Counter offer
                            </button>
                            <button
                              type="button"
                              className="al-btn al-btn--primary"
                              onClick={acceptOffer}
                              disabled={isResponding}
                            >
                              {isResponding
                                ? "Accepting…"
                                : `Accept ${formatMoney(respondTo?.price)}`}
                            </button>
                          </>
                        )
                      }
                    >
                      {/* The offer itself, so you are not deciding blind. */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 12,
                          padding: "13px 15px",
                          borderRadius: 11,
                          background: "var(--color-surface-2)",
                          border: "1px solid var(--color-border-soft)",
                          marginBottom: counterMode ? 18 : 0,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 10.5,
                            fontWeight: 700,
                            letterSpacing: ".05em",
                            textTransform: "uppercase",
                            color: "var(--color-text-tertiary)",
                          }}
                        >
                          Admin offered
                        </span>
                        <span
                          style={{
                            fontFamily: "var(--font-mono)",
                            fontWeight: 800,
                            fontSize: 16,
                            color: "var(--color-primary)",
                          }}
                        >
                          {formatMoney(respondTo?.price)}
                        </span>
                      </div>

                      {counterMode && (
                        <>
                          <div className="al-field">
                            <label className="al-label">
                              Your price
                              <span style={{ color: "var(--color-danger-text)" }}> *</span>
                            </label>
                            <input
                              className="al-input"
                              type="number"
                              min="0"
                              autoFocus
                              placeholder="e.g. 480"
                              value={counterPrice}
                              onChange={(e) => setCounterPrice(e.target.value)}
                            />
                            {counterErrors.price && (
                              <span className="al-err">{counterErrors.price}</span>
                            )}
                          </div>

                          <div className="al-field">
                            <label className="al-label">
                              Reason
                              <span style={{ color: "var(--color-danger-text)" }}> *</span>
                            </label>
                            <textarea
                              className="al-textarea"
                              rows="4"
                              placeholder="Why this price? e.g. material costs, quantity, delivery window"
                              value={counterReason}
                              onChange={(e) => setCounterReason(e.target.value)}
                            />
                            {counterErrors.reason && (
                              <span className="al-err">{counterErrors.reason}</span>
                            )}
                          </div>
                        </>
                      )}
                    </Modal>

                    {/* Product image gallery (thumbnail stack) */}
                    <ProductImagesModal
                      open={!!galleryItem}
                      onClose={() => setGalleryItem(null)}
                      images={galleryItem?.product?.product_image}
                      title={galleryItem?.order?.title || "Product Images"}
                    />

                    {/*
                      Full product specs + images (eye icon).
                      No `buyer` prop: a supplier quotes on the brief, not the
                      customer. It used to be passed `assignedBy` — the admin —
                      rendered under a "Buyer" heading, which was wrong twice
                      over. The API no longer sends buyer identity either.
                    */}
                    <OrderSpecsModal
                      open={!!specsItem}
                      onClose={() => setSpecsItem(null)}
                      order={specsItem?.order}
                      product={specsItem?.product}
                      extraFields={[
                        { label: "Assignment Status", value: specsItem?.status },
                        {
                          label: "Your Quotation",
                          value: specsItem?.quotation_price,
                        },
                        {
                          label: "Admin Quotation",
                          value: specsItem?.admin_quotation_price,
                        },
                      ]}
                    />

                    {openDesc && (
                      <div
                        style={{
                          position: "fixed",
                          inset: 0,
                          backgroundColor: "rgba(0,0,0,0.5)",
                          backdropFilter: "blur(2px)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 9999,
                          animation: "fadeIn 0.3s ease",
                        }}
                        onClick={(e) => {
                          if (e.target === e.currentTarget) setOpenDesc(false);
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#fff",
                            borderRadius: "16px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                            width: "90%",
                            maxWidth: "500px",
                            maxHeight: "90vh",
                            overflowY: "auto",
                            position: "relative",
                            padding: "24px",
                            animation: "fadeIn 0.3s ease",
                          }}
                        >
                          {/* Header */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              borderBottom: "1px solid #e5e7eb",
                              paddingBottom: "12px",
                              marginBottom: "16px",
                            }}
                          >
                            <h2
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                color: "#1f2937",
                                margin: 0,
                              }}
                            >
                              Full Product Description
                            </h2>
                            <button
                              onClick={() => setOpenDesc(false)}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#6b7280",
                                fontSize: "20px",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.color = "#374151")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.color = "#6b7280")
                              }
                            >
                              ×
                            </button>
                          </div>

                          {/* Body */}
                          <div
                            style={{
                              color: "#374151",
                              fontSize: "14px",
                              lineHeight: "1.6",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            {descContent}
                          </div>
                        </div>
                      </div>
                    )}

                    <RevertBackModal
                      show={showModal}
                      userId={userId}
                      order_assigned_id={order_assigned_id}
                      onClose={handleCloseModal}
                    />

                    {/* <DesignStudioModel
                      show={showDesignModal}
                      userId={userId}
                      orderId={orderid}
                      onClose={handleDesignCloseModal}
                    /> */}

                    <GraphicDesingerMokup
                      show={showDesignModal}
                      userId={userId}
                      orderId={orderid}
                      onClose={handleDesignCloseModal}
                    />
                  </div>
                </div>
                <div className="al-foot">
                  <span className="al-foot__info">
                    <strong>{data?.length || 0}</strong> order
                    {data?.length === 1 ? "" : "s"} shown
                  </span>
                  <div className="d-flex justify-content-center">
                    <div
                      className="dataTables_paginate paging_full_numbers"
                      id="alter_pagination_paginate"
                    >
                      {data?.length !== 0 ? (
                        <ReactPaginate
                          previousLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#515365"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-arrow-left"
                            >
                              <line x1="19" y1="12" x2="5" y2="12"></line>
                              <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                          }
                          nextLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#515365"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-arrow-right"
                            >
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                          }
                          breakLabel={"..."}
                          pageCount={totalpage}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-end m-0"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Inbound;
